import React, { useRef } from 'react';
import styled from 'styled-components';
import { compose } from 'recompose';

import { get } from 'Components/Base/constants';
import { withConfig } from 'Context/ConfigContext';
import { withOffset } from 'Context/LayoutContext';
import { Flex, ButtonFilled, Image, Text } from 'Components/Base';
import useQuickAccess from 'Util/Hooks/useQuickAccess';

const QuickAccessButtonListContainer = styled(Flex)`
  * {
    scroll-behavior: smooth;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

const QuickAccessWrapper = styled(Flex)`
  & > div:last-child {
    padding-right: 0;
  }
`;

const QuickAccessButton = styled((props) => (
  <ButtonFilled
    color={'white'}
    textColor={'text'}
    minWidth="auto"
    mr={4}
    px={3}
    py={2}
    {...props}
  />
))`
  box-shadow: ${get('shadows.primary')};
`;

const QuickAccess = ({ quickAccessItems, ...props }) => {
  const quickAccessListRef = useRef();
  const quickAccessList = useQuickAccess(quickAccessItems);

  return (
    <QuickAccessButtonListContainer {...props}>
      <QuickAccessWrapper ref={quickAccessListRef} id="quickAccess" style={{ overflowX: 'auto' }}>
        {quickAccessList.map((item) => {
          return (
            <QuickAccessButton key={item.title} onClick={item.onClick}>
              <Flex alignItems={'center'}>
                <Image width={'46px'} mr={2} src={item.src} />
                <Text textStyle={'heading5'}>{item.title}</Text>
              </Flex>
            </QuickAccessButton>
          );
        })}
      </QuickAccessWrapper>
    </QuickAccessButtonListContainer>
  );
};

export default compose(withConfig, withOffset)(QuickAccess);
